import { render, staticRenderFns } from "./SfTableHeading.vue?vue&type=template&id=121a9a47&"
import script from "./SfTableHeading.vue?vue&type=script&lang=ts&"
export * from "./SfTableHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports